export const ERRO_PAGAMENTO_EXPIRADO = 'Auth Failed: Payment Expired'
export const CHAVE_ERRO_AUTENTICACAO = 'erro-autenticacao-short-kc'

export const adicionarErroDePagamentoExpiradoNaSessao = () => {
  sessionStorage.setItem(CHAVE_ERRO_AUTENTICACAO, ERRO_PAGAMENTO_EXPIRADO)
}

export const removerErroDePagamentoExpiradoNaSessao = () => {
  sessionStorage.removeItem(CHAVE_ERRO_AUTENTICACAO)
}

export const possuiErroDePagamentoExpiradoDaSessao = () => {
  const chave = sessionStorage.getItem(CHAVE_ERRO_AUTENTICACAO)
  return chave === ERRO_PAGAMENTO_EXPIRADO
}